import { Pen } from "lucide-react";

export default function ModifyCode() {
  return (
    <div className="absolute top-1/2 pointer-events-none z-10 -translate-y-1/2 left-[2px] border-3 rounded-sm border-blue-500 size-7.5 animate-in fade-in duration-300">
      <div className="absolute border-3 border-blue-500 rounded-full -top-2.5 -left-[9px] z-1 pointer-events-none">
        <div className="relative  flex size-4.5 items-center justify-center rounded-full bg-white">
          <Pen size={11} className="text-blue-500" strokeWidth={2.5} />
        </div>
      </div>
    </div>
  );
}
